module.exports = __webpack_public_path__ + "img/pijltje-links-wit.d0903fe30eabefdf9324f2f21ed41e67.svg";